import { forwardRef, type SVGProps } from 'react';

export interface TextAlignEndIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const TextAlignEndIcon = forwardRef<SVGSVGElement, TextAlignEndIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M14 12.104C14.3107 12.104 14.5625 12.3558 14.5625 12.6665C14.5624 12.9771 14.3106 13.229 14 13.229H4.6665C4.35597 13.2289 4.10409 12.977 4.104 12.6665C4.104 12.3559 4.35592 12.1041 4.6665 12.104H14ZM14 7.43701C14.3106 7.43701 14.5624 7.68893 14.5625 7.99951C14.5625 8.31017 14.3107 8.56201 14 8.56201H6C5.68934 8.56201 5.4375 8.31017 5.4375 7.99951C5.43759 7.68893 5.68939 7.43701 6 7.43701H14ZM14 2.77051C14.3107 2.77051 14.5625 3.02235 14.5625 3.33301C14.5625 3.64367 14.3107 3.89551 14 3.89551H2C1.68934 3.89551 1.4375 3.64367 1.4375 3.33301C1.4375 3.02235 1.68934 2.77051 2 2.77051H14Z"
      fill="currentColor"
    />
  </svg>
));

TextAlignEndIcon.displayName = 'TextAlignEndIcon';
